import React from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import {
  getAllTransactionsAction,
  getAllTasksAction,
  createTaskAction,
  getAllTransactionsForFormsOnPermissionAction,
} from "../../actions/TransactionActions";
import { getVendorTransactionsAction } from "../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../actions/BuyerTransactionActions";
import { addDocAction, uploadDocumentAction } from "../../actions/DocActions";
import { addPublicFormAction } from "../../actions/PublicFormsActions";
import {
  formatPhoneNumber,
  getContingencyData,
  cryptoTokenDecode,
  toastMessage,
  convertTimeToMinutes,
  checkObjExists,
} from "../Common/Common";
import InputMask from "react-input-mask";
import SignaturePad from "react-signature-canvas";
import moment from "moment";
import html2pdf from "html2pdf.js";
import Dropzone from "react-dropzone";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import ImageUpload from "./ImageUpload";
import StickyHeader from "./StickyHeader";
import { AttachFile, HelpOutline, DeleteOutline } from "@material-ui/icons";
import UrlConstants from "../../config/UrlConstants";
import FormActionPrompt from "./FormActionPrompt";
import { Tooltip } from "@material-ui/core";
import { Upload, Send, Clear } from "@mui/icons-material";
import GenerateQRcode from "./GenerateQRcode";
import FormFooter from "./FormFooter";

var _ = require("lodash");

class IntakeForm extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      transactions: [],
      transaction: {},
      events: [],
      contingencies: [],
      attachments: [],
      appointmentDate: "",
      transactionId: "",
      isImageUploaded: false,
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      showSendPublicForm: false,
      showPrompt: false,
      promptType: "",
      showLoader: false,
      listedTransactions: [],
      files: [],
      transactionValidation: [],
      selectedTransClientEmail: "",
      showQRcodePrompt: false,
      errors: {},
    };

    this.exportFormToPDF = this.exportFormToPDF.bind(this);
    this.handleTransactionSelection = this.handleTransactionSelection.bind(
      this
    );
  }

  componentWillMount() {
    this.getAllTransactions();
  }

  handleTransactionSelection(e) {
    // console.log("handleTransactionSelection e", e);
    if (e) {
      this.setState({
        transaction: e,
        transactionValidation: e,
        transactionId: e.id,
        contingencies: e.contingencies,
        selectedTransClientEmail: e.hasGuardian
          ? e.guardianEmail
          : e.clientEmail,
        errors: {},
      });
    }

    this.getAllTasks(e.id);
  }

  clearTransactionSelection() {
    this.handleClosePrompt();
    this.uploadExtraDocuments();
    this.setState({
      transaction: {},
      transactionValidation: [],
      attachments: [],
      files: [],
      errors: {},
    });
  }

  handleShowPrompt(name) {
    this.setState({
      showPrompt: true,
      promptType: name,
    });
  }

  handleClosePrompt() {
    this.setState({
      showPrompt: false,
      promptType: "",
    });
  }

  handleShowQRcodePrompt() {
    this.setState({
      showQRcodePrompt: true,
    });
  }

  handleCloseQRcodePrompt() {
    this.setState({
      showQRcodePrompt: false,
    });
  }

  getAllTransactions(id) {
    // console.log('in getAllTransactions===============');
    this.setState({ showLoader: true });
    if (
      this.state.userType === message.VENDOR &&
      this.state.currentRole === message.BUYERAGENT
    ) {
      this.props.getVendorTransactionsAction().then((vendorRes) => {
        this.setState(
          {
            transactions: this.props.vendorTransactions.data || [],
            showLoader: false,
          },
          () => {
            this.getFilteredTransactions();
          }
        );
      });
    } else if (
      this.state.userType === message.BUYER &&
      this.state.currentRole === message.BUYER
    ) {
      this.props.getBuyerTransactionsAction().then((buyerRes) => {
        this.setState(
          {
            transactions: this.props.buyerTransactions.data || [],
            showLoader: false,
          },
          () => {
            this.getFilteredTransactions();
          }
        );
      });
    } else {
      this.props
        .getAllTransactionsForFormsOnPermissionAction("INPROGRESS")
        .then((res) => {
          // console.log('in getAllTransactions getAllTransactionsAction===============');
          // console.log('in getAllTransactions this.props.transactions.data===============',this.props.transactions.data);
          this.setState(
            {
              transactions: this.props.transactions.data || [],
              showLoader: false,
            },
            () => {
              this.getFilteredTransactions();
            }
          );
        });
    }
  }

  getFilteredTransactions() {
    //console.log('getFilteredTransactions ========');

    let transactions = this.state.transactions;
    let listedTransactions = [];
    for (let i = 0; i < transactions.length; i++) {
      listedTransactions.push({
        label:
          transactions[i].shortName +
          " - " +
          transactions[i].dsd.buyer[0].firstname +
          (transactions[i].dsd.buyer[0].lastname
            ? " " + transactions[i].dsd.buyer[0].lastname
            : ""),

        shortName: transactions[i].shortName,
        id: transactions[i]._id,
        clientFirstName: transactions[i].dsd.buyer[0].firstname,
        clientLastName: transactions[i].dsd.buyer[0].lastname
          ? transactions[i].dsd.buyer[0].lastname
          : "",
        clientEmail: transactions[i].dsd.buyer[0].email,
        clientPhone: transactions[i].dsd.buyer[0].mobileNumber,
        guardianName: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].firstname +
            (transactions[i].dsd.closingAgents[0].lastname
              ? " " + transactions[i].dsd.closingAgents[0].lastname
              : "")
          : "",
        guardianEmail: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].email
          : "",
        guardianPhone: transactions[i].dsd.closingAgents[0]
          ? transactions[i].dsd.closingAgents[0].mobileNumber
          : "",
        artistName:
          transactions[i].dsd.listingAgents[0].firstname +
          " " +
          transactions[i].dsd.listingAgents[0].lastname,
        transactionType: transactions[i].transactionType,
        description: transactions[i].dsd.heldBy,
        contingencies: transactions[i].contingencies,
        firstAppointment: moment(
          getContingencyData(
            transactions[i].contingencies,
            "First Appointment",
            "startDate"
          )
        ).format("MM/DD/YYYY"),
        status: transactions[i].status,
        hasGuardian:
          transactions[i].dsd.closingAgents.length !== 0 ? true : false,
      });
    }
    //console.log('getFilteredTransactions listedTransactions',listedTransactions);

    this.setState({
      listedTransactions: listedTransactions,
    });

    if (this.props.history.location.createdTrans) {
      // console.log('getFilteredTransactions if==========');
      // console.log('getFilteredTransactions if========== listedTransactions',listedTransactions);
      // console.log('getFilteredTransactions if========== this.props.history.location.createdTrans id',this.props.history.location.createdTrans._id);
      let defOption = listedTransactions.find(
        (option) => option.id === this.props.history.location.createdTrans._id
      );
      //  console.log('getFilteredTransactions intake defOption',defOption)
      this.handleTransactionSelection(defOption);
    }
  }

  getAllTasks(id) {
    this.props.getAllTasksAction(id).then((res) => {
      this.setState({
        events: this.props.tasks.data,
      });
    });
  }

  async exportFormToPDF(promptType) {
    this.handleClosePrompt();
    this.uploadExtraDocuments();
    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();

    let clientFullName =
      this.state.transaction.clientFirstName.trim() +
      (this.state.transaction.clientLastName
        ? " " + this.state.transaction.clientLastName.trim()
        : "");

    let fileName =
      "intake" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1200 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.addDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .uploadDocumentAction(formData, transId, undefined, fileUploadName)
            .then((isValidDoc) => {
              //Export the file for download
              html2pdf()
                .set(opt)
                .from(form)
                .save();
            });
          if (promptType === "uploadAndOpenConsent") {
            this.props.history.push({
              pathname: "/consent",
              createdTrans: { _id: transId },
            });
          }
        });
      } else {
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  uploadAttachments(e, transId) {
    let formData = new FormData();
    let documents = this.state.attachments;
    let docDetail = {};

    if (e.length > 0) {
      for (let i = 0; i < e.length; i++) {
        docDetail = {
          fileName: e[i].name,
          size: (e[i].size / (1024 * 1024)).toFixed(2),
        };
        documents.push(docDetail);
        // console.log("e[i]", e[i]);
        formData.append("file", e[i]);
      }

      this.setState({
        attachments: documents,
        files: [...this.state.files, ...e],
      });

      // let dataToPost = {
      //   transactionId: transId,
      //   location: "Transaction Docs",
      //   document: documents,
      // };

      // this.props.addDocAction(dataToPost).then((res) => {
      //   if (res.status === code.OK) {
      //     let fileUploadName = "";
      //     res.data.map((item) => {
      //       if (fileUploadName.length > 0) {
      //         fileUploadName +=
      //           "@@@" + item.document + "###" + item.uploadedFileName;
      //       } else {
      //         fileUploadName = item.document + "###" + item.uploadedFileName;
      //       }
      //     });

      //     this.props
      //       .uploadDocumentAction(formData, transId, undefined, fileUploadName)
      //       .then((res) => {
      //         // console.log('VALID');
      //       });
      //   } else {
      //     toastMessage(code.ERROR, res.data);
      //   }
      // });
    }
    // console.log("formData", formData);
  }

  uploadExtraDocuments = () => {
    let formData = new FormData();
    let dataToPost = {
      transactionId: this.state.transactionId,
      location: "Transaction Docs",
      document: this.state.attachments,
    };
    let e = this.state.files;
    if (e.length > 0) {
      for (let i = 0; i < e.length; i++) {
        // console.log("e[i]", e[i]);
        formData.append("file", e[i]);
      }
      // console.log("formData-380", formData);
      this.props.addDocAction(dataToPost).then((res) => {
        if (res.status === code.OK) {
          let fileUploadName = "";
          res.data.map((item) => {
            if (fileUploadName.length > 0) {
              fileUploadName +=
                "@@@" + item.document + "###" + item.uploadedFileName;
            } else {
              fileUploadName = item.document + "###" + item.uploadedFileName;
            }
          });
          this.props
            .uploadDocumentAction(
              formData,
              this.state.transactionId,
              undefined,
              fileUploadName
            )
            .then((res) => {
              // console.log('VALID');
            });
        } else {
          toastMessage(code.ERROR, res.data);
        }
      });
    }
  };

  /**
   * @desc delete image
   * @param {*} i
   */
  deleteImage(i) {
    var acceptedFiles = this.state.attachments;
    var filesData = this.state.files;
    filesData.splice(i, 1);
    acceptedFiles.splice(i, 1);
    this.setState({
      attachments: acceptedFiles,
      files: filesData,
    });
  }

  sendForm(transId) {
    this.setState({ showLoader: true });
    let transaction = this.state.transaction;
    let senderEmailToken =
      transaction && transaction.hasGuardian
        ? {
            email: "@guardian_email",
            firstname: "@guardian_firstname",
            lastname: "@guardian_lastname",
            dataValue: "guardian_firstname",
            contingency: "Guardian",
          }
        : transaction.clientEmail
        ? {
            email: "@client_email",
            firstname: "@client_firstname",
            lastname: "@client_lastname",
            dataValue: "client_firstname",
            contingency: "Client",
          }
        : "";
    let senderPhoneToken =
      transaction && transaction.hasGuardian
        ? {
            phone: "@guardian_phone",
            phoneValue: transaction.guardianPhone,
            firstname: "@guardian_firstname",
            lastname: "@guardian_lastname",
            contingency: "Guardian",
          }
        : transaction.clientPhone
        ? {
            phone: "@client_phone",
            phoneValue: transaction.clientPhone,
            firstname: "@client_firstname",
            lastname: "@client_lastname",
            contingency: "Client",
          }
        : "";

    this.handleClosePrompt();
    this.uploadExtraDocuments();
    let newEventStart = moment();
    let newEventEnd = moment();
    let newEventTime = convertTimeToMinutes(
      moment(newEventStart).get("hour") +
        ":" +
        moment(newEventStart).get("minutes")
    );

    let appoinmentDate = getContingencyData(
      this.state.contingencies,
      "First Appointment",
      "startDate"
    );

    let newPublicForm = {
      form: "intake",
      transactionId: transId,
      expiresOn: new Date(moment(appoinmentDate).subtract(5, "days")),
      auth: false,
    };

    this.props.addPublicFormAction(newPublicForm).then((newPubResIntake) => {});

    let newEvent = {
      assignee: "",
      campaign: "",
      communicationSubject: [
        `Intake Form for ${senderEmailToken.firstname} ${
          senderEmailToken.lastname
        }`,
      ],
      communicationTo: [senderEmailToken.email],
      communicationType: "EMAIL",
      contingency: senderEmailToken.contingency,
      day: 0,
      description: [
        `<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="${
          senderEmailToken.dataValue
        }">${
          senderEmailToken.firstname
        }</a>!</p><p></p><p>The intake form for your appointment on @first_appointment_date is available at the link below. Just copy and paste it into your browser. Please complete and submit it as soon as possible. Thanks!</p><p></p><p>@intake_form_url</p>`,
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "COMMUNICATION",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: [""],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: "Intake Form - Email",
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          this.setState({ showLoader: false });
          toastMessage(code.SUCCESS, "Form sent");
        }
      });
    }

    if (senderPhoneToken.phoneValue) {
      newEvent = {
        assignee: "",
        campaign: "",
        communicationSubject: [""],
        communicationTo: [senderPhoneToken.phone],
        communicationType: "TEXT",
        contingency: "Client",
        day: 0,
        description: [
          `Hey ${
            senderPhoneToken.firstname
          }! We emailed you the intake form for your appointment on @first_appointment_date. Please complete and submit it as soon as possible. Thanks!`,
        ],
        document: false,
        eventEndDate: newEventEnd,
        eventStartDate: newEventStart,
        eventType: "COMMUNICATION",
        isReminder: false,
        reminderDate: "",
        reminderTime: 540,
        specialTask: [""],
        status: "SCHEDULED",
        time: newEventTime,
        timeZone: "240",
        title: "Intake Form - Text",
        transactionId: transId,
      };

      if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
        this.props.createTaskAction(newEvent).then((createEventRes) => {
          if (createEventRes.status === code.OK) {
            this.setState({ showLoader: false });
          }
        });
      }
    }
  }

  handleChange = (e, key) => {
    if (
      this.state.transaction &&
      Object.keys(this.state.transaction).length > 0
    ) {
      this.setState({
        transaction: {
          ...this.state.transaction,
          [key]: e.target.value,
        },
      });
    }
  };

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    let attachments = this.state.attachments;

    // let transactions = this.state.transactions;
    let transaction = this.state.transaction;

    // let listedTransactions = [];

    //     console.log('on render load=-===-===== this.state.transactions',this.state.transactions);
    //     console.log('on render load this.props.transactions.data===============',this.props.transactions.data);

    //     for (let i = 0; i < transactions.length; i++) {
    //       listedTransactions.push({
    //         label:
    //           transactions[i].shortName +
    //           " - " +
    //           transactions[i].dsd.buyer[0].firstname +
    //           (transactions[i].dsd.buyer[0].lastname
    //             ? " " + transactions[i].dsd.buyer[0].lastname
    //             : ""),

    //         shortName: transactions[i].shortName,
    //         id: transactions[i]._id,
    //         clientName:
    //           transactions[i].dsd.buyer[0].firstname +
    //           " " +
    //           transactions[i].dsd.buyer[0].lastname,
    //         clientEmail: transactions[i].dsd.buyer[0].email,
    //         clientPhone: transactions[i].dsd.buyer[0].mobileNumber,
    //         guardianName: transactions[i].dsd.closingAgents[0]
    //           ? transactions[i].dsd.closingAgents[0].firstname +
    //             " " +
    //             transactions[i].dsd.closingAgents[0].lastname
    //           : "",
    //         guardianEmail: transactions[i].dsd.closingAgents[0]
    //           ? transactions[i].dsd.closingAgents[0].email
    //           : "",
    //         guardianPhone: transactions[i].dsd.closingAgents[0]
    //           ? transactions[i].dsd.closingAgents[0].mobileNumber
    //           : "",
    //         artistName:
    //           transactions[i].dsd.listingAgents[0].firstname +
    //           " " +
    //           transactions[i].dsd.listingAgents[0].lastname,
    //         transactionType: transactions[i].transactionType,
    //         description: transactions[i].dsd.heldBy,
    //         contingencies: transactions[i].contingencies,
    //         firstAppointment: moment(
    //           getContingencyData(
    //             transactions[i].contingencies,
    //             "First Appointment",
    //             "startDate"
    //           )
    //         ).format("MM/DD/YYYY"),
    //         status: transactions[i].status,
    //         hasGuardian:
    //           transactions[i].dsd.closingAgents.length !== 0 ? true : false,
    //       });
    //     }
    // if (this.state.showLoader) {
    //   return (
        // <div className="page-loader fixed">
        //   <div className="page-loader-inner">
        //     <div className="spinner-border" role="status">
        //       <span className="sr-only">Loading...</span>
        //     </div>
        //   </div>
        // </div>
      // );
    // } else {
      return (
        <div className="admin-steps admin-content-area">
          {this.state.showLoader && (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          )}
          <StickyHeader
            listedTransactions={this.state.listedTransactions}
            transaction={this.state.transaction}
            handleTransactionSelection={this.handleTransactionSelection.bind(
              this
            )}
            handleShowPrompt={this.handleShowPrompt.bind(this)}
            selectedTransClientEmail={
              this.state.selectedTransClientEmail
            }
            handleShowQRcodePrompt={this.handleShowQRcodePrompt.bind(
              this
            )}
            formType="intake"
            errorHandler={this.errorHandler.bind(this)}
          />
          <div className="container-custom">
            <Form className="form-sm form-admin" id="formToExport">
              <Row>
                <Col xs={12} sm={7}>
                  <Row>
                    <Col xs={12}>
                      <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                        Client Information
                      </h4>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group
                    controlId=""
                    className="dropzone-transaction-wrapper"
                  >
                    <div className="mt-4">
                      <ImageUpload />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>
                      Client First Name
                      <span className="text-danger"> *</span>:
                    </Form.Label>
                    <Form.Control
                      onChange={(e) =>
                        this.handleChange(e, "clientFirstName")
                      }
                      value={
                        checkObjExists(transaction)
                          ? transaction.clientFirstName
                          : ""
                      }
                      isInvalid={!!this.state.errors.clientFirstName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.clientFirstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Client Last Name:</Form.Label>
                    <Form.Control
                      onChange={(e) =>
                        this.handleChange(e, "clientLastName")
                      }
                      value={
                        checkObjExists(transaction)
                          ? transaction.clientLastName
                          : ""
                      }
                      isInvalid={!!this.state.errors.clientLastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.clientLastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <Form.Control
                      value={
                        checkObjExists(transaction)
                          ? transaction.clientEmail
                          : ""
                      }
                      onChange={(e) =>
                        this.handleChange(e, "clientEmail")
                      }
                      type="email"
                      name="clientEmail"
                      id="clientEmail"
                      isInvalid={!!this.state.errors.clientEmail}
                    />
                    <Form.Control.Feedback type="invalid">
                      {this.state.errors.clientEmail}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Mobile Number:</Form.Label>
                    <InputMask
                      mask="999-999-9999"
                      maskChar=""
                      formControlProps={{
                        fullWidth: true,
                      }}
                      onChange={(e) =>
                        this.handleChange(e, "clientPhone")
                      }
                      value={
                        checkObjExists(transaction)
                          ? formatPhoneNumber(transaction.clientPhone)
                          : ""
                      }
                      name="clientPhone"
                      id="clientPhone"
                    >
                      {(inputProps) => <Form.Control {...inputProps} />}
                    </InputMask>
                    {this.state.errors.clientPhone && (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {this.state.errors.clientPhone}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Date of Birth:</Form.Label>
                    <InputMask
                      mask="99/99/9999"
                      maskChar=""
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="emergencyPhone"
                    >
                      {(inputProps) => <Form.Control {...inputProps} />}
                    </InputMask>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Address:</Form.Label>
                    <Form.Control />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>City:</Form.Label>
                    <Form.Control />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>State:</Form.Label>
                    <Form.Control />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Zip Code:</Form.Label>
                    <Form.Control />
                  </Form.Group>
                </Col>
              </Row>

              {transaction.hasGuardian ? (
                <>
                  <Row>
                    <Col xs={12} sm={7}>
                      <Row>
                        <Col xs={12}>
                          <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                            Guardian Information
                          </h4>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>
                          Name<span className="text-danger"> *</span>:
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="guardianName"
                          id="guardianName"
                          value={
                            checkObjExists(transaction)
                              ? transaction.guardianName
                              : ""
                          }
                          onChange={(e) =>
                            this.handleChange(e, "guardianName")
                          }
                          isInvalid={!!this.state.errors.guardianName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.guardianName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Date of Birth:</Form.Label>
                        <InputMask
                          mask="99/99/9999"
                          maskChar=""
                          formControlProps={{
                            fullWidth: true,
                          }}
                          name="emergencyPhone"
                        >
                          {(inputProps) => (
                            <Form.Control {...inputProps} />
                          )}
                        </InputMask>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Email:</Form.Label>
                        <Form.Control
                          value={
                            checkObjExists(transaction)
                              ? transaction.guardianEmail
                              : ""
                          }
                          onChange={(e) =>
                            this.handleChange(e, "guardianEmail")
                          }
                          type="email"
                          name="guardianEmail"
                          id="guardianEmail"
                          isInvalid={!!this.state.errors.guardianEmail}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.guardianEmail}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Group>
                        <Form.Label>Phone:</Form.Label>

                        <InputMask
                          mask="999-999-9999"
                          maskChar=""
                          formControlProps={{
                            fullWidth: true,
                          }}
                          onChange={(e) =>
                            this.handleChange(e, "guardianPhone")
                          }
                          value={
                            checkObjExists(transaction)
                              ? formatPhoneNumber(
                                  transaction.guardianPhone
                                )
                              : ""
                          }
                          name="guardianPhone"
                        >
                          {(inputProps) => (
                            <Form.Control {...inputProps} />
                          )}
                        </InputMask>
                        {this.state.errors.guardianPhone && (
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {this.state.errors.guardianPhone}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}

              <Row>
                <Col xs={12} sm={7}>
                  <Row>
                    <Col xs={12}>
                      <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                        Artwork Information
                      </h4>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Appointment Date:</Form.Label>
                    <Form.Control
                      value={
                        checkObjExists(transaction)
                          ? transaction.firstAppointment
                          : ""
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Artist Name:</Form.Label>
                    <Form.Control
                      value={
                        checkObjExists(transaction)
                          ? transaction.artistName
                          : ""
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Artwork Type:</Form.Label>
                    <Form.Control
                      value={
                        checkObjExists(transaction)
                          ? transaction.transactionType
                          : ""
                      }
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Artwork Description:</Form.Label>
                    <Form.Control
                      value={
                        checkObjExists(transaction)
                          ? transaction.description
                          : ""
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={7}>
                  <Row>
                    <Col xs={12}>
                      <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                        Emergency Contact
                      </h4>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Name:</Form.Label>
                    <Form.Control />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Phone:</Form.Label>
                    <InputMask
                      mask="999-999-9999"
                      maskChar=""
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="emergencyPhone"
                    >
                      {(inputProps) => <Form.Control {...inputProps} />}
                    </InputMask>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={7}>
                  <Row>
                    <Col xs={12}>
                      <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                        Client Health Information
                      </h4>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Label className="title-sm font-600">
                    Allergies:
                  </Form.Label>
                  <Form.Group>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Antibiotics
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Metals
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Soaps
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Latex
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Alcohol
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Cosmetics
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Adhesives
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Petroleum
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Lanolin Oil
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Lidocaine
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Shellfish
                      </label>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Label className="title-sm font-600">
                    Diseases:
                  </Form.Label>
                  <Form.Group>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Hepatitis
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Tuberculosis
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Gonorrhea
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Syphilis
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        HIV/AIDS
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Herpes
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Staph
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Auto-Immunity
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Asthma
                      </label>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={3}>
                  <Form.Label className="title-sm font-600">
                    Medical History:
                  </Form.Label>
                  <Form.Group>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Heart Disease
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        High Blood Pressure
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Diabetes
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Pregnant
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Prone to Fainting
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Skin Disease/Rash
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Epilepsy
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Hemophilia
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                      >
                        Prone to Scarring/Keloiding
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Psoriasis
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                      />
                      <label
                        class="form-check-label"
                        for="flexCheckChecked"
                      >
                        Eczema
                      </label>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>
                      How Long Since You Last Ate?
                    </Form.Label>
                    <Form.Control />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>
                      {transaction.hasGuardian
                        ? "Guardian Signature"
                        : "Client Signature"}
                    </Form.Label>
                    <div
                      style={{
                        border: "solid 1px lightgray",
                        width: "100%",
                        height: "70px",
                        overflow: "hidden",
                      }}
                    >
                      <SignaturePad
                        canvasProps={{
                          width: 400,
                          height: 70,
                          className: "sigCanvas",
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                  <Form.Group>
                    <Form.Label>Date:</Form.Label>
                    <Form.Control
                      value={moment().format("MM/DD/YYYY")}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>

          <hr />

          <div className="container-custom">
            <p style={{ marginBottom: "25px" }}>
              <b> * Add additional attachments</b>
            </p>

            <Row>
              <Col xs={12} sm={4}>
                <div
                  style={{
                    backgroundColor: "#f8f8f8",
                    padding: "20px",
                    margin: "0px 25px 25px 25px",
                  }}
                >
                  <Dropzone
                    maxSize={100000000}
                    accept={[
                      "image/*",
                      "application/pdf",
                      "application/msword",
                      ".docx",
                      ".xml",
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    ]}
                    onDrop={(acceptedFiles) => {
                      this.uploadAttachments(
                        acceptedFiles,
                        this.state.transactionId
                      );
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          className="dropzone-transaction drop-task"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <AttachFile />
                          <p>
                            <strong>
                              Click or drag and drop to add attachments
                            </strong>
                          </p>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>
              </Col>
              <Col xs={12} sm={4}>
                <h4 className="user-name">Attachments</h4>
                <div className="comments-thread mt-0 pb-5">
                  {attachments
                    ? attachments.map((attachment, i) => {
                        return (
                          <Row className="user-list mx-0 align-items-center">
                            <Col className="pl-4">
                              <div className="comments-text">
                                {/* <a
                              href={
                                UrlConstants.AdminCreateTransactionUrl +
                                "/upload?id=" +
                                this.state.transactionId +
                                "&img=" +
                                attachment.name
                              }
                            >
                              <h4 className="user-name">
                                {attachment.fileName}
                              </h4>
                            </a> */}
                                <h4 className="user-name">
                                  {attachment.fileName}
                                </h4>
                              </div>
                            </Col>
                            <Col>
                              <Button
                                variant="transparent"
                                onClick={() => {
                                  this.deleteImage(i);
                                }}
                              >
                                <DeleteOutline />
                              </Button>
                            </Col>
                          </Row>
                        );
                      })
                    : ""}
                </div>
              </Col>
            </Row>
            <FormFooter
              transaction={this.state.transaction}
              handleShowPrompt={this.handleShowPrompt.bind(this)}
              selectedTransClientEmail={
                this.state.selectedTransClientEmail
              }
              handleShowQRcodePrompt={this.handleShowQRcodePrompt.bind(
                this
              )}
              formType="intake"
              errorHandler={this.errorHandler.bind(this)}
            />
            {/* <Row>
            <Col style={{ padding: "0px 0px 40px 40px" }}>
              <Tooltip placement="bottom" title="Upload form">
                <Button
                  name="upload"
                  variant="primary"
                  className="text-uppercase sticky-header-btn mr-2"
                  onClick={() => this.handleShowPrompt("upload")}
                  disabled={this.state.transactionValidation.length === 0}
                  style={
                    this.state.transactionValidation.length === 0
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : {}
                  }
                >
                  <Upload />
                </Button>
              </Tooltip>

              <Tooltip placement="bottom" title="Send form">
                <Button
                  name="send"
                  variant="primary"
                  className="text-uppercase sticky-header-btn mr-2"
                  onClick={() => this.handleShowPrompt("send")}
                  disabled={
                    this.state.transactionValidation.length === 0
                      ? true
                      : this.state.selectedTransClientEmail === ""
                      ? true
                      : false
                  }
                  style={
                    // this.props.transaction.length === 0
                    //   ? { backgroundColor: "gray", borderColor: "gray" }
                    //   : {}
                    this.state.transactionValidation.length === 0
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : this.state.selectedTransClientEmail === ""
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : {}
                  }
                >
                  <Send />
                </Button>
              </Tooltip>

              <Tooltip placement="bottom" title="Clear artwork">
                <Button
                  name="clear"
                  variant="primary"
                  className="text-uppercase sticky-header-btn"
                  onClick={(e) => this.handleShowPrompt("clear")}
                  disabled={this.state.transactionValidation.length === 0}
                  style={
                    this.state.transactionValidation.length === 0
                      ? { backgroundColor: "gray", borderColor: "gray" }
                      : {}
                  }
                >
                  <Clear />
                </Button>
              </Tooltip>
            </Col>
          </Row> */}
          </div>
          <FormActionPrompt
            transaction={this.state.transaction}
            promptType={this.state.promptType}
            showPrompt={this.state.showPrompt}
            exportFormToPDF={this.exportFormToPDF.bind(this)}
            sendForm={this.sendForm.bind(this)}
            handleClosePrompt={this.handleClosePrompt.bind(this)}
            clearTransactionSelection={this.clearTransactionSelection.bind(
              this
            )}
          />
          <GenerateQRcode
            transaction={this.state.transaction}
            formType="intake"
            showQRcodePrompt={this.state.showQRcodePrompt}
            handleCloseQRcodePrompt={this.handleCloseQRcodePrompt.bind(
              this
            )}
          />
        </div>
      );
    // }
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    transactions: state.reducer.transactions,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    tasks: state.reducer.tasks,
    addPublicFormData: state.reducer.addPublicFormData,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllTransactionsAction,
    getVendorTransactionsAction,
    getBuyerTransactionsAction,
    getAllTasksAction,
    uploadDocumentAction,
    addDocAction,
    createTaskAction,
    addPublicFormAction,
    getAllTransactionsForFormsOnPermissionAction,
  }
)(IntakeForm);
